import { render } from "./AdminProductView.vue?vue&type=template&id=b14469fe"
import script from "./AdminProductView.vue?vue&type=script&lang=js"
export * from "./AdminProductView.vue?vue&type=script&lang=js"

import "./AdminProductView.vue?vue&type=style&index=0&id=b14469fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__